import { render, staticRenderFns } from "./ContractProbationAlertOverview.vue?vue&type=template&id=f254ae22&scoped=true"
import script from "./ContractProbationAlertOverview.vue?vue&type=script&lang=js"
export * from "./ContractProbationAlertOverview.vue?vue&type=script&lang=js"
import style0 from "./ContractProbationAlertOverview.vue?vue&type=style&index=0&id=f254ae22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f254ae22",
  null
  
)

export default component.exports